import Link from 'next/link';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { useScreenDetect } from 'src/hooks/useScreenDetect';
import { Button } from 'src/ui/common/atoms/button';
import { canvasAnimationSpeed } from 'src/ui/common/config/animations';
import { useGradientAnimation } from 'src/ui/common/hooks/useGradientAnimation.hook';
import {
    StyledBanner,
    StyledButtonsWrapper,
    StyledCanvas,
    StyledDescription,
    StyledTitle,
} from './landing-bottom-banner.styles';

interface ILocale {
    title: string;
    text: string;
    createNftButton: string;
    learnHow: string;
    createCollectButton: string;
}

export const LandingBottomBannerContainer = () => {
    const { t } = useTranslation(['pages']);
    const screenType = useScreenDetect();

    const locale: ILocale = useMemo(
        () => ({
            ...t('home.widgets.bottomBanner', { ns: 'pages', returnObjects: true }),
        }),
        [t]
    );

    const { ref: canvasRef, entry: canvas, inView } = useInView();
    const { startAnimation, stopAnimation } = useGradientAnimation();

    useEffect(() => {
        if (inView) {
            startAnimation(canvas!.target as HTMLCanvasElement, canvasAnimationSpeed.slow);
        }
        if (!inView) {
            stopAnimation();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inView, canvas]);

    return (
        <StyledBanner>
            <StyledCanvas ref={canvasRef} width="32" height="32" />
            <StyledTitle size={screenType.xs ? 'md' : 'xl'} variant="title" color="black">
                {locale.title}
            </StyledTitle>
            <StyledDescription size="sm" variant="text" color="black">
                {locale.text}
            </StyledDescription>
            <StyledButtonsWrapper>
                <Link href="https://home.spaceseven.com/platform-as-a-service ">
                    <a target="_blank">
                        <Button variant="white" size={screenType.xs ? 'md' : 'lg'}>
                            {locale.learnHow}
                        </Button>
                    </a>
                </Link>
            </StyledButtonsWrapper>
        </StyledBanner>
    );
};
